export function HeaderIcon({ icon, url }) {
    return (
        <a href={url} className="headerRoute flex h-full items-center justify-center pl-4 pr-4">
            {icon}
        </a>
    );
}
